/**
 * Cart Drawer Free Gifts - Accordion
 * File: assets/cart-free-gifts-accordion.js
 *
 * Adds a smooth open/close slide animation on top of the native
 * <details class="cart__free-gift--accordion"> / <summary> markup in
 * snippets/cart-drawer-free-gifts.liquid. Native <details> toggles
 * instantly with no animation, so this intercepts the click, drives the
 * open/close by transitioning the height of the content wrapper, and lets
 * the <details> element's own open/closed state follow along afterwards.
 *
 * Progressive enhancement: if this script fails to load, clicking the
 * summary still works via the browser's native <details> toggle - it just
 * snaps open/closed instead of sliding.
 *
 * Uses event delegation on `document` (registered once) instead of
 * attaching listeners to specific elements, so this keeps working after
 * GiftManager (assets/free-gift.liquid) replaces the whole
 * .cart__free-gift--outer node wholesale on every AJAX cart update - no
 * re-initialization needed.
 */
(function () {
  'use strict';

  if (window.NOBLFreeGiftsAccordionLoaded) return;
  window.NOBLFreeGiftsAccordionLoaded = true;

  function getContent(details) {
    return details.querySelector(':scope > .cart__free-gift--accordion-content');
  }

  document.addEventListener('click', function (event) {
    var summary = event.target.closest('.cart__free-gift--accordion > summary');
    if (!summary) return;

    var details = summary.parentElement;
    var content = getContent(details);
    // Markup doesn't match what this script expects - fall back to the
    // browser's native (unanimated) <details> toggle rather than doing
    // nothing.
    if (!content) return;

    event.preventDefault();
    if (details.classList.contains('is-animating')) return;

    if (details.open) {
      // Currently open -> capture the current rendered height as a concrete
      // starting point (it may be 'auto' right now), then animate to 0.
      // The <details> element itself is only marked closed once the
      // animation finishes (see the transitionend handler below).
      var currentHeight = content.getBoundingClientRect().height;
      content.style.height = currentHeight + 'px';
      // Force a reflow so the browser registers that starting height
      // before we change it again - otherwise the two style writes get
      // batched and it jumps straight to closed with no transition.
      // eslint-disable-next-line no-unused-expressions
      content.offsetHeight;

      details.classList.add('is-animating');
      details.dataset.closing = 'true';
      // Flip the arrow back down now, in sync with the slide starting -
      // not at the end of the animation. `details.open` itself only
      // flips to false once the slide finishes (see transitionend below),
      // so the caret's rotation CSS keys off this class instead of [open]
      // - otherwise the arrow stays pointed "up" for the entire close
      // animation and only snaps down abruptly at the very last instant.
      details.classList.remove('is-open');
      requestAnimationFrame(function () {
        content.style.height = '0px';
      });
    } else {
      // Must open the <details> first so its content is in the render tree
      // and has a real scrollHeight to animate to.
      details.open = true;
      content.style.height = '0px';
      // eslint-disable-next-line no-unused-expressions
      content.offsetHeight;

      details.classList.add('is-animating');
      delete details.dataset.closing;
      // Flip the arrow up in sync with the slide starting (see the
      // matching comment in the close branch above).
      details.classList.add('is-open');
      requestAnimationFrame(function () {
        content.style.height = content.scrollHeight + 'px';
      });
    }
  });

  document.addEventListener('transitionend', function (event) {
    var content = event.target;
    if (
      !content.classList ||
      !content.classList.contains('cart__free-gift--accordion-content') ||
      event.propertyName !== 'height'
    ) {
      return;
    }

    var details = content.closest('details.cart__free-gift--accordion');
    if (!details) return;

    details.classList.remove('is-animating');

    if (details.dataset.closing === 'true') {
      // Finished animating closed - hand off to the native <details>
      // closed state and clear the inline height so it doesn't fight with
      // future opens.
      details.open = false;
      delete details.dataset.closing;
      content.style.height = '';
    } else {
      // Finished animating open - switch to 'auto' so if the gift list's
      // own content changes size later (e.g. a quantity badge appearing),
      // it isn't clipped to the stale pixel height we animated to.
      content.style.height = 'auto';
    }
  });
})();
